module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-9-882bb981bf3ee27e4761c797654211b3.jpg";